/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} My_AccountInputs */

const en_my_account = /** @type {(inputs: My_AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`My Account`)
};

const th_my_account = /** @type {(inputs: My_AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`บัญชีของฉัน`)
};

const ja_my_account = /** @type {(inputs: My_AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`マイアカウント`)
};

const fr_my_account = /** @type {(inputs: My_AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mon compte`)
};

const es_my_account = /** @type {(inputs: My_AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mi cuenta`)
};

const ru_my_account = /** @type {(inputs: My_AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Мой аккаунт`)
};

const zh_my_account = /** @type {(inputs: My_AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`我的账户`)
};

const vi_my_account = /** @type {(inputs: My_AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tài khoản của tôi`)
};

/**
* | output |
* | --- |
* | "My Account" |
*
* @param {My_AccountInputs} inputs
* @param {{ locale?: "en" | "th" | "ja" | "fr" | "es" | "ru" | "zh" | "vi" }} options
* @returns {LocalizedString}
*/
export const my_account = /** @type {((inputs?: My_AccountInputs, options?: { locale?: "en" | "th" | "ja" | "fr" | "es" | "ru" | "zh" | "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<My_AccountInputs, { locale?: "en" | "th" | "ja" | "fr" | "es" | "ru" | "zh" | "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_my_account(inputs)
	if (locale === "ja") return ja_my_account(inputs)
	if (locale === "fr") return fr_my_account(inputs)
	if (locale === "es") return es_my_account(inputs)
	if (locale === "ru") return ru_my_account(inputs)
	if (locale === "zh") return zh_my_account(inputs)
	if (locale === "vi") return vi_my_account(inputs)
	return en_my_account(inputs)
});